<script setup lang="ts">
import isIBAN from 'validator/es/lib/isIBAN'
import isBIC from 'validator/es/lib/isBIC'
import { InputText } from '#components'

const t2 = useT2({
  'Save bank account': 'Išsaugoti banko sąskaitą',
  'Bank Name': 'Banko pavadinimas',
  'Account Holder Full Name': 'Sąskaitos savininko vardas ir pavardė',
  enterMsg: {
    en: "Please enter the account holder's full name so we can process your refund without additional clarification.",
    lt: 'Įveskite sąskaitos savininko vardą ir pavardę, kad pinigų grąžinimą galėtume atlikti be papildomų patikslinimų.',
  },
  'Account Number (IBAN)': 'Sąskaitos numeris (IBAN)',
  'Incorrect Bank Account Number': 'Neteisingas sąskaitos numeris',
  'Incorrect SWIFT Code': 'Neteisingas SWIFT kodas',
})

const props = defineProps<{
  values: undefined | gen.InputSellerPayoutBank
  submit(value: gen.InputSellerPayoutBank): NotVoid
}>()

const bankAccount = {
  refs: useRefs({
    bankAccountNumber: InputText,
    bankAcconutHolderName: InputText,
    bankTitle: InputText,
    bankSwift: InputText,
  }),
  submit() {
    const values = getFormValue(this.refs)
    return props.submit({
      bankAccountNumber: helpers.required(values.bankAccountNumber, 'Missing Bank Account'),
      bankAcconutHolderName: helpers.required(values.bankAcconutHolderName, 'Missing Bank Holder Name'),
      bankTitle: helpers.required(values.bankTitle, 'Missing Bank Title'),
      bankSwift: helpers.required(values.bankSwift, 'Missing SWIFT Code'),
    })
  },
}

const validateBankAccount: MyInputError<string>[] = [
  {
    isErr: (i) => !isIBAN(i),
    msg: t2('Incorrect Bank Account Number'),
  },
]
const validateSWIFT: MyInputError<string>[] = [
  {
    isErr: (i) => !isBIC(i),
    msg: t2('Incorrect SWIFT Code'),
  },
]

const DF = {
  // iban: 'GB29NWBK60161331926819',
  // swift: 'CBVILT2X',
  // bank: 'SEB',
  // name: 'Nojus Lenciauskas',
  iban: '',
  swift: '',
  bank: '',
  name: '',
}
</script>

<template>
  <MyForm :form="bankAccount" :txt="t2('Save bank account')">
    <InputText :ref="bankAccount.refs.bankTitle" :label="t2('Bank Name')" :model-value="values?.bankTitle || DF.bank" />
    <div>
      <InputText :ref="bankAccount.refs.bankAcconutHolderName" :label="t2('Account Holder Full Name')" :model-value="values?.bankAcconutHolderName || DF.name" />
      <span class="_pl1 _p1 _pb08 _italic">{{ t2('enterMsg') }}</span>
    </div>
    <InputText :ref="bankAccount.refs.bankAccountNumber" :label="t2('Account Number (IBAN)')" :model-value="values?.bankAccountNumber || DF.iban" :validate="validateBankAccount" />
    <InputText :ref="bankAccount.refs.bankSwift" :label="ts('BIC/SWIFT')" :model-value="values?.bankSwift || DF.swift" :validate="validateSWIFT" />
  </MyForm>
</template>
